"use client";
import {
  chip_default
} from "./chunk-J7I6W5JF.mjs";
import {
  useChip
} from "./chunk-QNFSJ4AJ.mjs";
export {
  chip_default as Chip,
  useChip
};
